'use strict';

export default {
  reports: {
    existingReports: 'Existing reports',
    addReport: 'Add Report',
    cancel: 'Cancel',
    delete: 'Delete',
    deleteReports: 'Delete this report ?',
    deleteModal: 'Report to delete',
    generate: 'Generate',
    save: 'Save',
    checkAll: 'Check All',
    uncheckAll: 'Uncheck All',
    noFields: 'No Fields',
    formId: "Form's Id: ",
    saveSuccess: 'Report successfully saved',
    createSuccess: 'Report successfully created',
    updateReportError: 'Error while saving report',
    createReportError: 'Error while creating report',
    reportName: 'Report name',
    emptyReportName: 'Please give the report a valid name',
    noReports: 'There are no reports yet for this organization',
    noSavedReports: 'There are no saved reports yet',
    returnToReports: 'Return to reports',
    toForms: 'Go to forms page',
    viewReports: 'View reports',
    editReport: 'Edit report',
    downloadReport: 'Download report',
    deleteReport: 'Delete report',
    paymentStepName: 'Payments',
    paymentSectionName: 'Payments',
    adminSectionName: 'Administration',
    adminStepName: 'General',
    formTotalPaid: 'Total paid',
    paymentMethod: 'Payment method',
    paymentStatus: 'Payment status',
    submissionId: 'Submission Id',
    discount: 'Discount',
    paymentMode: 'Payment mode',
    discountCode: 'Discount code',
    submissionDate: 'Submission Date',
    receiptEmail: 'Receipt Email',
  },
};
